import React, { CSSProperties, useId } from "react";

import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import { bem } from "@react-md/utils";
import cn from "classnames";

const block = bem("mmc-gradient-icon");

export interface GradientIconProps extends FontAwesomeIconProps {
  from?: string;
  to?: string;
}

const GradientIcon = ({ className, from, style, to, ...faProps }: GradientIconProps) => {
  const rawId = useId();
  const id = `gradient-icon-${rawId.replace(/:/g, "")}`;

  const mergedStyle: CSSProperties = {
    ...style,
    ["--gradient-icon-fill" as string]: `url(#${id})`,
  };
  if (from) {
    (mergedStyle as Record<string, string>)["--gradient-icon-from"] = from;
  }
  if (to) {
    (mergedStyle as Record<string, string>)["--gradient-icon-to"] = to;
  }

  return (
    <span className={cn(block(), className)} style={mergedStyle}>
      <svg aria-hidden className={block("defs")} focusable="false">
        <defs>
          <linearGradient id={id} x1="0" x2="1" y1="0" y2="0">
            <stop offset="0" stopColor="var(--gradient-icon-from)" />
            <stop offset="1" stopColor="var(--gradient-icon-to)" />
          </linearGradient>
        </defs>
      </svg>
      <FontAwesomeIcon {...faProps} />
    </span>
  );
};

export default GradientIcon;
